import React, { Component } from 'react';
import '../App.css';
import {Link} from 'react-router-dom';
import MakePost from './MakePost';
/* global moment */
/* global $ */

export default class User extends Component {
  constructor(props){
    super(props);
    this.state = {
      'user_loaded': false,
      'user_data': undefined,
      'modal_body': null,
      'delete_pid': null,
      'comment_content_cid': '',
    }
  }
  
  update_data(uid) {
    let firebase = this.props.app_state.firebase;
    firebase.database().ref('/main/users/'+uid).on('value', (snap) => {
        if (snap.val() === null) {/*
          return firebase.database().ref('/main/pending_users/'+uid).on('value', (snap2) => {
              let temp_user_data = snap2.val();
              
              if (temp_user_data === null)
                return;
              
              temp_user_data['pending'] = true;
              this.setState({'user_data': temp_user_data, 'user_loaded': true});
            });*/
            this.setState({'user_loaded': true});
            return;
        }
        let temp_user_data = snap.val();
        temp_user_data['pending'] = false;
        this.setState({'user_data': temp_user_data, 'user_loaded': true});
      });
  }

  delete_post(e, pid, title) {    
    e.stopPropagation();
    
    let modal_body = <div className="modal_body">
      You are about to delete the following post:<br/>
      <t style={{"fontWeight":"bold"}}>{title}</t><br/>
      Please confirm
    </div>;
    $('#user_really').modal('show');
    this.setState({'modal_body': modal_body, 'delete_pid': pid});
  }
  confirm_delete() {
    let firebase = this.props.app_state.firebase;
    $('#alert_working').fadeIn().delay(1500).fadeOut();
    
    let for_db = {};
    for_db[this.state.delete_pid+'/deleted'] = true;
    $('#user_really').modal('hide');
    firebase.database().ref('/main/posts').update(for_db)
      .then(() => {
        $('#alert_dark').text('Deleting Post').fadeIn().delay(2000).fadeOut();
      })
      .catch((error) => {
        $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
      });
  }
  
  confirm_report_user (){
    let firebase = this.props.app_state.firebase;
    
    if ($('#report_user_message').val() === '') {
      $('#alert_danger').text('Please add a message').fadeIn().delay(2000).fadeOut();
      return;
    }
    
    let for_db = {};
    for_db['reporter'] = (this.props.app_state.this_user||{}).id;
    for_db['reporter_name'] = (this.props.app_state.this_user||{}).name;
    for_db['type'] = 'user';
    for_db['reported_id'] = window.location.pathname.split('/')[2];
    for_db['reported_time'] = Date.now();
    for_db['comment'] = $('#report_user_message').val();
    let rep_id = 'r_'+Date.now()+'_'+Math.floor(Math.random() * 1000);
    for_db['id'] = rep_id;
    firebase.database().ref('/main/reports/'+rep_id).update(for_db)
      .then(() => {
        $('#alert_dark').text('Report Submitted').fadeIn().delay(1500).fadeOut();
        $('#report_user').modal('hide');
        $('#report_user_message').val('');
      })
      .catch((error) => {
        $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();        
      });    
  }
  
  update_uid = '';
  componentDidUpdate() {    
    let uid = window.location.pathname.split('/')[2];
    // user change
    if (uid !== this.update_uid
          && (typeof this.state.this_user === 'undefined' || this.state.this_user['id'] !== uid)) {
      this.update_data(uid);
    }
    this.update_uid = uid;
  }
  
  componentDidMount() {    
    let user_key = window.location.pathname.split('/')[2];
    this.update_data(user_key);
    
    
    var waitForEl = (selector, callback) => {
      if ($(selector).length && this.props.app_state.this_user_loaded) {
        callback();
      } else {
        if (this.props.app_state.this_user_loaded && this.props.app_state.this_user === null)
          return;
        setTimeout(function() {
          waitForEl(selector, callback);
        }, 100);
      }
    };
    waitForEl('#user_link', () => {
      if (user_key === this.props.app_state.this_user.id) {
        $('#user_link').addClass('bold');
      }
    });
    
    let waitForCurrUser = (callback) => {
      if (this.state.user_loaded) {
        callback();
      } else {
        setTimeout(() => {
          waitForCurrUser(callback);
        }, 100);
      }
    };
    waitForCurrUser( () => {
      let firebase = this.props.app_state.firebase;
      let this_user = this.state.user_data;
      if (this_user && (typeof this_user.comments !== 'undefined' && Object.keys(this_user.comments).length > 0
            || typeof this_user.blog_comments !== 'undefined' && Object.keys(this_user.blog_comments).length > 0)) {
        let db = firebase.database().ref('/main');
        for (let cid in this_user.comments||[]) {
          let this_comment = this_user.comments[cid];
          if (!this_comment.post_id || this_comment.post_id === '')
            continue;
          db.child('/posts/'+this_comment.post_id+'/comments').on('value', (snap) => {
            let comments = snap.val();
            if (this_comment.reply_to_type === 'post') {
              // separate location for each comment to avoid race conditions 
              let for_state = {};
              for_state['comment_content_'+cid] = comments[cid].content;
              this.setState(for_state)
            }
            else if (this_comment.reply_to_type === 'comment') {
              let parent_comment = comments[this_comment.reply_to];
              let for_state = {};
              for_state['comment_content_'+cid] = parent_comment.comments[cid].content;
              this.setState(for_state);              
            }
          });
        }
        for (let bid in this_user.blog_comments||[]) {
          let this_comment = this_user.blog_comments[bid];
          if (!this_comment.post_id || this_comment.post_id === '')
            continue;
          db.child('/blog_posts/'+this_comment.post_id+'/comments').on('value', (snap) => {
            let comments = snap.val();
            if (this_comment.reply_to_type === 'blog') {
              // separate location for each comment to avoid race conditions 
              let for_state = {};
              for_state['comment_content_'+bid] = comments[bid].content;
              this.setState(for_state)
            }
            else if (this_comment.reply_to_type === 'blog_comment') {
              let parent_comment = comments[this_comment.reply_to];
              let for_state = {};
              for_state['comment_content_'+bid] = parent_comment.comments[bid].content;
              this.setState(for_state);              
            }
          });
        }
      }
    });
  }
  componentWillUnmount() {
    $('#user_link').removeClass('bold');
  }
  
  render() {
    let page = window.location.pathname.split('/')[3] || 'about';
    page = page.toLowerCase();
    let uid = window.location.pathname.split('/')[2];
    if (!uid || uid === '')
      return (<h3>User not found</h3>);
      
    let is_current_user = false;
    if (this.props.app_state.this_user_loaded 
            && this.props.app_state.this_user !== null
            && uid === this.props.app_state.this_user.id) {
      $('#user_link').addClass('bold');
      is_current_user = true;
    }
    let this_user = this.state.user_data;
    let loaded = this.state.user_loaded;
    
    if(typeof this_user === 'undefined')
      if(loaded)
        return (<h3>User not found</h3>);
      else
        return (<h3 className="text-muted">Loading...</h3>)
    
    
    let fav_xml = [];
    if (typeof this_user.fav_categories !== 'undefined') {
      for (var i = 0; i < this_user.fav_categories.length; i++){
        fav_xml.push(<Link to={'/category/'+this_user.fav_categories[i]}>
          {cat_names[this_user.fav_categories[i]]} 
        </Link>);
        if(i !== (this_user.fav_categories.length-1))
          fav_xml.push(', ');
      }
      fav_xml = [
        <hr/>,
        <p className="user_fav_cats"><span className="text-muted">Favorite Categories:</span> {fav_xml}</p>,
        <hr/>
      ];
    }
    
    // posts
    let posts_xml;
    if (is_current_user)
      posts_xml = <p className="text-muted">Your posts will appear here</p>;
    else
      posts_xml = <p className="text-muted">This user has not created any posts.</p>;
    if (typeof this_user.posts !== 'undefined' && Object.keys(this_user.posts).length > 0) {
      posts_xml = [];
      let posts_list = [];      
      for (let pid in this_user.posts) {
        posts_list.push(this_user.posts[pid]);
      }
      posts_list.sort((b, a) => {
        return a.pub_time - b.pub_time;
      });
      
      posts_list.forEach((this_post) => {
        let pid = this_post.id;
        let post_btns = null;
        let this_title = this_post.title;
        if (is_current_user) {
          post_btns = <div className="user_post_btns_div">
            <Link to={"/post/"+pid}><button className="btn btn-dark">View</button></Link>
            <Link to={"/post/"+pid+"#edit"}><button className="mid_btn btn btn-dark">Edit</button></Link>
            <button className="btn btn-outline-danger"
                    onClick={(e) => this.delete_post(e, pid, this_title)}>Delete</button>
          </div>;
        }
        posts_xml.push(
        <Link to={'/post/'+pid}>
          <div className="user_post_container">
            <t className="user_post_title">{this_post.title}</t><br/>
            <t className="user_post_details">
              {moment(this_post.pub_time).fromNow()}&nbsp;
              •&nbsp; in:<Link to={'/category/'+(this_post.category||'miscellaneous').toLowerCase()}>
                            {cat_names[(this_post.category||'miscellaneous').toLowerCase()]}&nbsp;</Link>
              •&nbsp; {this_post.num_comments} comment{(this_post.num_comments === 1)?'':'s'}
            </t>
          </div>
        </Link>);
        posts_xml.push(post_btns);
        posts_xml.push(<hr/>);
      });
    }
    
    
    // comments
    let comments_xml;
    if (is_current_user)
      comments_xml = <p className="text-muted">Your comments will appear here</p>;
    else
      comments_xml = <p className="text-muted">This user has not created any comments.</p>;
    if (typeof this_user.comments !== 'undefined' && Object.keys(this_user.comments).length > 0
        || typeof this_user.blog_comments !== 'undefined' && Object.keys(this_user.blog_comments).length > 0) {
      comments_xml = [];
      let comments_list = [];      
      for (let cid in this_user.comments||[]) {
        comments_list.push(this_user.comments[cid]);
      } 
      for (let bid in this_user.blog_comments||[]) {
        comments_list.push(this_user.blog_comments[bid]);
      }
      comments_list.sort((b, a) => {
        return a.pub_time - b.pub_time;
      });
      
      comments_list.forEach((this_comment) => {
        let cid = this_comment.id;
        let this_content;
        this_content = this.state['comment_content_'+cid] || '...';
        
        if (this_comment.reply_to_type === 'blog' || this_comment.reply_to_type === 'blog_comment')
          comments_xml.push(
          <Link to={'/blog/'+this_comment.post_id}>
            <div className="user_com_container">
              <p className="user_com_content">
                {this_content.substr(0, 180)}
                {(this_content.length > 180)?'...':''}
              </p>
              <t className="user_com_details">
                {moment(this_comment.pub_time).fromNow()}&nbsp;
                •&nbsp; on:<Link to={'/blog'}> {this_comment.post_title||this_comment.post_id}&nbsp;</Link>
              </t>
            </div>
          </Link>);
        else
          comments_xml.push(
          <Link to={'/post/'+this_comment.post_id}>
            <div className="user_com_container">
              <p className="user_com_content">
                {this_content.substr(0, 180)}
                {(this_content.length > 180)?'...':''}
              </p>
              <t className="user_com_details">
                {moment(this_comment.pub_time).fromNow()}&nbsp;
                •&nbsp; on:<Link to={'/post/'+this_comment.post_id}> {this_comment.post_title||this_comment.post_id}&nbsp;</Link>
              </t>
            </div>
          </Link>);
        //comments_xml.push(comment_btns);
        comments_xml.push(<hr/>);
      });
    }
    
    
    // Bookmarks
    let bookmarks_xml = [];
    let user_bookmarks = [];
    let mark_dict = (this_user||{}).bookmarks||{};
    let blog_mark_dict = (this_user||{}).blog_bookmarks||{};
    let mark_post;
    let this_pid;
    let this_bid;
    let this_mark;
    for (let mark_key in mark_dict) {
      this_mark = mark_dict[mark_key];
      this_mark['time'] = this_mark.time || 0;
      this_mark['type'] = 'post';
      user_bookmarks.push(this_mark);
    }
    for (let mark_key in blog_mark_dict) {
      this_mark = blog_mark_dict[mark_key];
      this_mark['time'] = this_mark.time || 0;
      this_mark['type'] = 'blog';
      user_bookmarks.push(this_mark);
    }
    user_bookmarks.sort((b, a) => {
      return a.time - b.time;
    });
    
    
    for (let i = 0; i < user_bookmarks.length; i++) {
      if (user_bookmarks[i].type === 'blog') {
        this_bid = user_bookmarks[i].post_id;
        mark_post = this.props.app_state.blogs_dict[this_bid];
        if (!mark_post)
          continue;
        bookmarks_xml.push(
          <Link to={"/blog/"+this_bid}>
            <div className="bookmark_cont">
              <t className="user_post_title">{mark_post.title}</t><br/>
              <t className="user_post_details">
                {moment(mark_post.pub_time).fromNow()}&nbsp;
                •&nbsp; in:<Link to={'/blog'}>
                              For the Love of People&nbsp;</Link>
                •&nbsp; {mark_post.num_comments||'0'} comment{(mark_post.num_comments === 1)?'':'s'}
              </t>
            </div>
          </Link>
        );
        bookmarks_xml.push(<hr/>);
      }
      else {
        this_pid = user_bookmarks[i].post_id;
        mark_post = this.props.app_state.posts_info_dict[this_pid];
        if (!mark_post)
          continue;
        bookmarks_xml.push(
          <Link to={"/post/"+this_pid}>
            <div className="bookmark_cont">
              <t className="user_post_title">{mark_post.title}</t><br/>
              <t className="user_post_details">
                {moment(mark_post.pub_time).fromNow()}&nbsp;
                •&nbsp; in:<Link to={'/category/'+(mark_post.category||'miscellaneous').toLowerCase()}>
                              {cat_names[(mark_post.category||'miscellaneous').toLowerCase()]}&nbsp;</Link>
                •&nbsp; {mark_post.num_comments} comment{(mark_post.num_comments === 1)?'':'s'}
              </t>
            </div>
          </Link>
        );
        bookmarks_xml.push(<hr/>);
      }      
    }
    if (bookmarks_xml.length === 0) {
      bookmarks_xml = <p>No bookmarks</p>;
    }
    
    let rep_btn = null;
    if(this.props.app_state.this_user) {
      rep_btn = <p className="report_user_btn"
          onClick={e => $('#report_user').modal('show')}>
        Report this User
      </p>;
    }
    
    
    // settings    
    let settings_btn = null;
    if (is_current_user)
      settings_btn = <Link to={"/user/"+this_user.id+"/settings"}>
        <div className={"bar_btn" + ((page==='settings')?" active":"")}>
          <i className="material-icons">settings</i>
          <span className="bar_btn_text">Settings</span>
        </div>
      </Link>;
    
    let settings_xml = null;
    if (page==='settings' && is_current_user) {
      let wants_courage = false;
      if (typeof this.props.app_state.this_user.wants_courage !== 'undefined')
        wants_courage = this.props.app_state.this_user.wants_courage;
      
      settings_xml = [
        <h3>Emails</h3>,
        <div className="setting_item">Weekly Encouragement Emails
          <label className="switch">
            <input type="checkbox" defaultChecked={wants_courage}
                    onChange={()=>{
                      let wants_courage = false;
                      if (typeof this.props.app_state.this_user.wants_courage !== 'undefined')
                        wants_courage = this.props.app_state.this_user.wants_courage;
                      
                      let firebase = this.props.app_state.firebase;
                      firebase.database().ref('/main/users_sen/'
                        +this.props.app_state.this_user.id+'/wants_courage').set(!wants_courage)
                        .then(() => {
                          $('#alert_dark').text('Email settings updated')
                                                      .fadeIn().delay(1500).fadeOut();
                        })
                        .catch((error) => {
                          $('#alert_danger').text(error.message)
                                              .fadeIn().delay(3000).fadeOut();
                        });
                      
                    }}/>
            <span className="slider round"></span>
          </label>
        </div>,
        <hr/>
      ];
    }
    
    
    return (
      <div id="user_div">
        <p className="user_name">{this_user.name}</p>
        <div className="btn_container">
          <Link to={"/user/"+this_user.id+"/about"}>
            <div className={"bar_btn" + ((page==='about')?" active":"")}>
              <i className="material-icons">person</i>
              <span className="bar_btn_text">About</span>
            </div>
          </Link>
          <Link to={"/user/"+this_user.id+"/posts"}>
            <div className={"bar_btn" + ((page==='posts')?" active":"")}>
              <i className="material-icons">create</i>
              <span className="bar_btn_text">Posts</span>
            </div>
          </Link>
          <Link to={"/user/"+this_user.id+"/comments"}>
            <div className={"bar_btn" + ((page==='comments')?" active":"")}>
              <i className="material-icons chat">chat</i>
              <span className="bar_btn_text">Comments</span>
            </div>
          </Link>
          <Link to={"/user/"+this_user.id+"/bookmarks"}>
            <div className={"bar_btn" + ((page==='bookmarks')?" active":"")}>
              <i className="material-icons">bookmark</i>
              <span className="bar_btn_text">Bookmarks</span>
            </div>
          </Link>
          {settings_btn}
        </div>
        {(() => {
          switch (page) {
            case 'about':
              return [<p className="text-muted">Helper Points: {this_user.helper_points}</p>,
              fav_xml];
            case 'posts':
              if (is_current_user) {
                /*
                
                  <div id="make_post" className="col-sm">
                    <h3>New Post</h3>
                    <MakePost app_state={this.props.app_state} />
                    <hr id="user_collapsed_divider"/>
                  </div>
                  */
                return <div className="row">
                  <div id="all_user_posts" className="col-sm">
                    {posts_xml}                    
                  </div>
                </div>;
              }
              else 
                return <div id="all_user_posts">
                  {posts_xml}
                </div>;
            case 'comments':
                return <div id="all_user_coms">
                  {comments_xml}
                </div>;
            case 'bookmarks':
              return <div id="all_bookmarks">
                {bookmarks_xml}
              </div>;
            case 'settings':
              return <div id="all_settings">
                {settings_xml}
              </div>;
            default:
              return [<p className="text-muted">Helper Points: {this_user.helper_points}</p>,
              fav_xml];
          }
        })()}
        {rep_btn}
        
        <div id="user_really" className="modal fade" tabindex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Are you sure?</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            
            {this.state.modal_body}
            
            <div style={{'margin-top': '20px'}} className="modal-footer">
              <button onClick={this.confirm_delete.bind(this)} type="button" className="btn btn-dark">Confirm</button>
              <button type="button" className="btn btn-outline-danger" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
        </div>
        
        <div id="report_user" className="modal fade" tabindex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">What's wrong?</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal_body">
              <strong>You are about to report this user</strong>. <br/>
              <strong>Say why</strong>:
              <textarea id="report_user_message" 
                          className="form-control"
                          placeholder="Message...">
              </textarea>
            </div>
            
            <div style={{'margin-top': '20px'}} className="modal-footer">
              <button onClick={this.confirm_report_user.bind(this)} type="button" className="btn btn-dark">Confirm</button>
              <button type="button" className="btn btn-outline-danger" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
        </div>
      </div>
    );
  }
}

const cat_names = {
  'relationships': 'Relationships',
  'mentalhealth': 'Mental Health',
  'sexualorientation': 'Sexual Orientation',
  'loss': 'Loss',
  'race': 'Race',
  'suicide': 'Suicide',
  'abuse': 'Abuse',
  'addiction': 'Addiction',
  'eatingdisorders': 'Eating Disorders',
  'miscellaneous': 'Miscellaneous',
  'religion': 'Religion',
}



// WEBPACK FOOTER //
// ./src/components/User.js